// extracted by css-extract-rspack-plugin
export default {"container":"_14yt9RiMo_eXBWsCjMdoGw","innerContainer":"_18ZC1y6iDIuYcfoT5Q_ndv"};